// src/components/Copyright.js
import React from 'react';

function Copyright() {
  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="max-w-[1200px] mx-auto p-8 bg-white rounded-lg shadow-lg">
        <h1 className="text-center mb-8 text-4xl font-extrabold text-gray-900">
          著作権・知的財産権
        </h1>
        <p className="text-gray-700">
          本サービスに関する著作権・知的財産権はすべて運営者に帰属します。利用者は、運営者の事前の許可なく、本サービスのコンテンツを
          無断で転載・使用することはできません。引用を行う際には、引用元として当サイトの名称およびURLを明示してください。
        </p>
      </div>
    </div>
  );
}

export default Copyright;
